import { type Veranstaltung } from '../dtos';

export const getVeranstaltungStart = (veranstaltung: Pick<Veranstaltung, 'ablauf'>): Date =>
  veranstaltung.ablauf
    .map((ablaufTag) => ablaufTag.start)
    .reduce((previous, current) => (current < previous ? current : previous));

export const getVeranstaltungEnd = (veranstaltung: Pick<Veranstaltung, 'ablauf'>): Date =>
  veranstaltung.ablauf
    .map((ablaufTag) => ablaufTag.end)
    .reduce((previous, current) => (current > previous ? current : previous));
